import { render } from "./Children.vue?vue&type=template&id=2c2fddde&scoped=true&ts=true"
import script from "./Children.vue?vue&type=script&lang=ts"
export * from "./Children.vue?vue&type=script&lang=ts"

import "./Children.vue?vue&type=style&index=0&id=2c2fddde&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2fddde"]])

export default __exports__